import { Container, Sprite } from '../../../odie';
import { ButterflyBlockProps } from '../../defs/block';
import { getMatch2AssetPath } from '../../util/assets';
import { MovieClip } from '@play-co/timestep-core/ui';
import { blockPositionView } from '../../util/blockTools';

const manifest = () => ({
  movieclip: {
    url: getMatch2AssetPath('blocks/butterfly'),
    loadMethod: MovieClip.animationLoader,
  },
});

export class ButterflyBlockView extends Container {
  public readonly sprite: Sprite;
  private movieclip: MovieClip;

  constructor(props: ButterflyBlockProps) {
    super();

    this.sprite = new Sprite();
    this.addChild(this.sprite);

    this.movieclip = new MovieClip({
      superview: this.sprite.view,
      url: manifest().movieclip.url,
      scale: 0.9,
    });
    blockPositionView(this, props);
    this.startAnimation();
  }

  private async startAnimation() {
    await this.movieclip.playAsync('worm_transition_2_3');
    this.movieclip.play('worm_state03', null, true);
  }

  public stopAnimation(): void {
    this.movieclip.stop();
  }

  public static assets() {
    return Object.values(manifest());
  }
}
